/**
 * Utility functions for Employee Updates
 */

import { Employee } from "../../../../store/slices/employeeUpdatesSlice";

/**
 * Creates a clean copy of employee data suitable for Redux storage,
 * without any circular references or React components
 */
export const createCleanEmployeeData = (empData: any): Employee => {
  // Create a clean copy with only the fields we need
  return {
    id: Number(empData.id), // Ensure id is cast to a number
    firstName: empData.firstName || "",
    lastName: empData.lastName || "",
    gpid: empData.gpid || "",
    status: empData.status || "",
    jobDescription: empData.jobDescription || "",
    lastObservation: empData.lastObservation || "",
    lastPulseCheck: empData.lastPulseCheck || "",
    hireDate: empData.hireDate || "",
    graduationDate: empData.graduationDate || "",
    terminationDate: empData.terminationDate || "",
    manager: empData.manager || "",
    // Convert display symbols back to boolean if necessary
    newHire:
      typeof empData.newHire === "string"
        ? empData.newHire === "●"
        : !!empData.newHire,
    isDeleted: empData.isDeleted || false,
  };
};
